import React, { useEffect, useMemo, useState } from 'react'
import { enrichBlogProductRefs } from '../../../api/marketing/buildRelatedProductSearchIndex'
import { loadRelatedProductCatalogCached } from '../../../api/blog/loadRelatedProductCatalogCached'
import BlogProductSetTiles from './BlogProductSetTiles'

/** Resolves avatar/price from catalog for display without requiring settings open. */
function BlogProductSetBlock({ block }) {
  const [searchIndex, setSearchIndex] = useState(null)

  useEffect(() => {
    let cancelled = false
    loadRelatedProductCatalogCached()
      .then((data) => {
        if (!cancelled) setSearchIndex(Array.isArray(data) ? data : [])
      })
      .catch(() => {
        if (!cancelled) setSearchIndex([])
      })
    return () => {
      cancelled = true
    }
  }, [])

  const refs = useMemo(
    () => enrichBlogProductRefs(block.productRefs || [], searchIndex || []),
    [block.productRefs, searchIndex]
  )

  if (!refs.length && !block.title) return null

  return <BlogProductSetTiles title={block.title || ''} productRefs={refs} />
}

export default BlogProductSetBlock
